import { Navigate, Route, Routes } from "react-router-dom";
import EmployeeLogin from "./EmployeeLogin";
import Login from "./Login";
// import Register from "./Register";

function AuthMain() {
  return (
    <div>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/employee" element={<EmployeeLogin />} />
        <Route path="/login/employee" element={<EmployeeLogin />} />
        <Route path="*" element={<Navigate to="/" />} />

        {/* <Route path="/register" element={<Register />} /> */}
      </Routes>
    </div>
  );
}

export default AuthMain;
